import { Timestamp } from 'firebase/firestore'
import * as z from 'zod'

export type DocID = string

export type TDocSchema<T extends z.ZodObject> = z.ZodObject<{
  id: z.ZodString
  entity: T
  createdAt: z.ZodType<Timestamp>
  updatedAt: z.ZodType<Timestamp>
}>

export type TEntity<T extends z.ZodObject> = z.input<T>

export type TDoc<T extends z.ZodObject> = z.output<TDocSchema<T>>

export type TStrictResult<T, Strict extends boolean> = Strict extends true
  ? T
  : T | null

export const createDocSchema = <T extends z.ZodObject>(
  schema: T
): TDocSchema<T> =>
  z.object({
    id: z.string(),
    entity: schema,
    createdAt: z.instanceof(Timestamp),
    updatedAt: z.instanceof(Timestamp),
  })
